import AttendanceDetailList from "./attendanceDetailList";
export default AttendanceDetailList;